<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp1"> </p>
<p class="Dedication-ded"><span class="ePub-I"><span epub:type="pagebreak" id="pg_5" title="5">Writing is my journey,</span></span></p>
<p class="Dedication-ded"><span class="ePub-I">It is how I make sense of the world.</span></p>
<p class="Dedication-ded"><span class="ePub-I">These people I come to know in the books show me.</span></p>
<p class="Dedication-ded"><span class="ePub-I">They speak to me. They lead me to my truth.</span></p>
<p class="Dedication-ded"><span class="ePub-I">They give to me my sight.</span></p>
<p class="Dedication-ded"><span class="ePub-I">So this is to Aoleyn,</span></p>
<p class="Dedication-ded"><span class="ePub-I">Who made me look at the world from a different angle</span></p>
<p class="Dedication-ded"><span class="ePub-I">And in a different light.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?683a6c9a